"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
exports.amplitudeKeys = void 0;

var _analytics = require("../../analytics");

var amplitudeKeys = {
  PROD: "7f16887a33920c71f9292164c94bbba5",
  TEST: "42222a494c44f7899bdbf101fa1a42f5"
};
exports.amplitudeKeys = amplitudeKeys;

function init(isProd, options) {
  var key = isProd ? amplitudeKeys.PROD : amplitudeKeys.TEST;
  return (0, _analytics.initialize)(key, options);
}